export const ENVIRONMENT = {
  PRODUCTION: "production",
  STAGING: "staging",
  DEVELOPMENT: "development",
} as const;

export type TEnvironment = (typeof ENVIRONMENT)[keyof typeof ENVIRONMENT];
